import {config} from 'config/config'
import useCookies from '@/modern/hooks/useCookies'

const { urlLogin } = config

export default () => {
  const {getChannelInCookies} = useCookies()
  const origin = getChannelInCookies()

  const getLoginURL = () => {
    const defaultUrl = urlLogin + encodeURIComponent(window.location.href)
    const url =  !origin ? defaultUrl
                         : `${defaultUrl}&origem=${origin}`

    return url
  }

  const addOrigin = (url = '') => {
    const hasParametersInUrl = url.includes('?')
    const concat = hasParametersInUrl ? '&' : '?'
    return origin ? `${concat}origem=${origin}` : ''
  }

  const addOriginMediaZeroKm = (url = '', mediaZeroKm) => {
    const hasParametersInUrl = url.includes('?')
    const concat = hasParametersInUrl ? '&' : '?'
    return mediaZeroKm ? `${concat}origin=rb` : ''
  }


    return {
      getLoginURL,
      addOrigin,
      addOriginMediaZeroKm
    }
}
